// 雲端全時錄影功能暫停（Eddy 2026-09-28：統一測試後再開放，vms-web §5.9）：帳務總覽 continuous_available = false 時
// 全時席次不能買（API 回 422 FEATURE_DISABLED），畫面把它灰掉、標「即將開放」。既有席次照常顯示。
import type { BillingOverview, VmsProduct } from '../../lib/planeApi';

export function productComingSoon(p: Pick<VmsProduct, 'kind' | 'mode'>, d: Pick<BillingOverview, 'continuous_available'>): boolean {
  return p.kind === 'seat' && p.mode === 'continuous' && !d.continuous_available;
}
